import { Injectable } from '@angular/core';
import { AccountColorsApi, IColorPickerSetting } from './api/account-colors.api';
import { Store } from 'rxjs-observable-store';
import { Logger } from '../monitoring/logger/logger';

export class AccountColorsState {
  id: string;
  colors: string;
  isLoadingColorPickerSettings: boolean;
}

@Injectable()
export class AccountColorsService extends Store<AccountColorsState> {

  private readonly defaultColors = '#FFFFFF,#000000,#2889e9,#e920e9,#fff500,#90EE90';
  constructor(private colorEditorApi: AccountColorsApi, private logger: Logger) {
    super(new AccountColorsState());
  }

  getColors() {
    this.patchState(true as any, 'isLoadingColorPickerSettings');
    this.colorEditorApi.getColors().subscribe((data: IColorPickerSetting) => {
      let colors = data.SelectedColors;
      if (!colors) {
        colors = this.defaultColors;
      }
      this.updateState(data.Id, colors, false);
    }, (error: any) => {
      this.logger.error(error);
      this.updateState(null, null, false);
    });
  }

  setColors(colors: string) {
   if (this.state.isLoadingColorPickerSettings === undefined) {
      return;
    }

    const coclorsData: IColorPickerSetting = {
      SelectedColors: colors,
      Id: this.state.id
    };
    this.patchState(true as any, 'isLoadingColorPickerSettings');

    return this.colorEditorApi.setColors(coclorsData).subscribe(() => {
      this.updateState(this.state.id, colors, false);
    }, (error) => {
      this.logger.error(error);
      this.patchState(false as any, 'isLoadingColorPickerSettings');
    });
  }

  private updateState(id: string, colors: string, isLoadingColorPickerSettings: boolean) {
    const newState = Object.assign(new AccountColorsState(), {
      id: id,
      colors: colors,
      isLoadingColorPickerSettings: isLoadingColorPickerSettings
    });

    this.setState(newState);
  }
}
